export var STORE_GRID_ACTIONS = {
  NEXT_BATCH_OF_STORES: 'next_batch_of_stores',
  PREVIOUS_BATCH_OF_STORES: 'previous_batch_of_stores'
};